module.exports = __webpack_public_path__ + "images/emoji/clock130.5fcae5f17994480c42ea.png";